module.exports = __webpack_public_path__ + "static/media/loading-icon.32c7506f.svg";